import { render, staticRenderFns } from "./orderDetailShow.vue?vue&type=template&id=b9d7b5fc&scoped=true"
import script from "./orderDetailShow.vue?vue&type=script&lang=js"
export * from "./orderDetailShow.vue?vue&type=script&lang=js"
import style0 from "./orderDetailShow.vue?vue&type=style&index=0&id=b9d7b5fc&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9d7b5fc",
  null
  
)

export default component.exports